// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"error_innerWrapper__Y08lS","heading":"error_heading__Uq6TO","description":"error_description__lXVJJ","button":"error_button__PP5n_"};